import { Injectable } from '@angular/core';
import { Parameter } from 'projects/common/src/app/classes';
import { take, filter } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { IRawApplication } from 'projects/common/src/app/interfaces/remote-models/raw-application';

@Injectable({
  providedIn: 'root'
})
export class TargetAppService extends Parameter<IRawApplication> {

  constructor() {
    super();
    this.name = 'target-application';
  }

  public init(): Promise<IRawApplication> {
    this.alreadyStarted = true;
    return new Promise((resolve) => {
      this.sourceSubject.pipe(take(1)).subscribe(arg0 => resolve(arg0));
    });
  }

  public startWhen(source: Observable<IRawApplication[]>): void {
    this.subscription = source.pipe(
      filter((data) => !!data),
    ).subscribe(data => {
      this.alreadyStarted = true;
      this.set(data[0]);
    });
  }

  /**
   * Returns the id of current application
   */
  public getId(): number {
    if (this.hasValue()) {
      return this.get().menuId;
    }
    return null;
  }
}
